import { useEffect, useState } from 'react';
import { Card, Col, Divider, Form, message, Modal, Popconfirm, Radio, Row, Space } from 'antd';
import { BookyCheckbox } from '../../Components/Forms/BookyCheckbox';
import { WebApiCompanyDtoCompanyDto, WebApiIntegrationsDtoIntegrationSyncConfigDto, WebApiIntegrationsDtoIntegrationDto, } from '../../Repository/eventbookyapi';
import { AuthProvider } from '../../Providers/authProvider';
import { useAuth } from '../../Contexts/AuthContext';
import { TextService } from '../../Services/TextService';
import { ApiOutlined, CheckCircleOutlined, DeleteOutlined, ExclamationCircleOutlined, FilePdfOutlined, FileSearchOutlined, FileTextOutlined, InfoCircleOutlined, SettingOutlined, SyncOutlined } from '@ant-design/icons';
import Paragraph from 'antd/lib/typography/Paragraph';
import LeftMenuSettings from './LeftSettings';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BookyButton } from '../../Components/Buttons/BookyButton';
import { IntegrationService } from '../../Services/IntegrationService';
import { IntegrationType } from '../../Types/IntegrationType';
import { IntegrationState } from '../../Types/IntegrationState';
import { formatDateString } from '../../Helpers/DateHelpers';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import { CompanyService } from '../../Services/CompanyService';
import { MemberFieldService } from '../../Services/MemberFieldService';
import { MemberFieldTypes } from '../../Types/MemberFieldTypes';

const AdminIntegrations = () => {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const showSpirisIntegration = true;
    const [activeIntegrations, setActiveIntegrations] = useState([] as WebApiIntegrationsDtoIntegrationDto[]);

    const { user } = useAuth();
    const GetText = TextService.GetText;
    const { confirm } = Modal;
    const [searchParams, setSearchParams] = useSearchParams();
    const [isLoadingFortnox, setIsLoadingFortnox] = useState(false as boolean);
    const [isLoadingPingPayments, setIsLoadingPingPayments] = useState(false as boolean);
    const [isLoadingSpirisVisma, setIsLoadingSpirisVisma] = useState(false as boolean);
    const [integrationToDelete, setIntegrationToDelete] = useState(0 as number);
    const [fortNoxIntegration, setFortNoxIntegration] = useState(null as WebApiIntegrationsDtoIntegrationDto | null);
    const [spirisVismaIntegration, setSpirisVismaIntegration] = useState(null as WebApiIntegrationsDtoIntegrationDto | null);
    const [company, setCompany] = useState(null as WebApiCompanyDtoCompanyDto | null);

    const [pingPaymentsIntegration, setPingPaymentsIntegration] = useState(null as WebApiIntegrationsDtoIntegrationDto | null);
    const [showPingPaymentsInfo, setShowPingPaymentsInfo] = useState(false);
    const [showFortnoxInfo, setShowFortnoxInfo] = useState(false);
    const [showSpirisInfo, setShowSpirisInfo] = useState(false);

    const [lastRunCount, setLastCountRun] = useState(null as WebApiIntegrationsDtoIntegrationDto | null);

    const [showSyncConfig, setShowSyncConfig] = useState(false);
    const [isSavingSyncConfig, setIsSavingSyncConfig] = useState(false);
    const [syncConfigIntegrationType, setSyncConfigIntegrationType] = useState<IntegrationType>(IntegrationType.Fortnox);
    const [syncConfigForm] = Form.useForm<WebApiIntegrationsDtoIntegrationSyncConfigDto>();
    const [extra1Label, setExtra1Label] = useState('Extra1');
    const [extra2Label, setExtra2Label] = useState('Extra2');
    const [extra3Label, setExtra3Label] = useState('Extra3');

    var hasInitConnection = false;
    const navigation = useNavigate();

    useEffect(() => {
        CompanyService.GetCompany().then(company => {
            setCompany(company);
        })

        MemberFieldService.GetMemberFields().then(fields => {
            const e1 = fields.find(f => f.columnType === MemberFieldTypes.Extra1 as any);
            const e2 = fields.find(f => f.columnType === MemberFieldTypes.Extra2 as any);
            const e3 = fields.find(f => f.columnType === MemberFieldTypes.Extra3 as any);
            if (e1?.nameAdmin) setExtra1Label(`Extra1 (${e1.nameAdmin})`);
            if (e2?.nameAdmin) setExtra2Label(`Extra2 (${e2.nameAdmin})`);
            if (e3?.nameAdmin) setExtra3Label(`Extra3 (${e3.nameAdmin})`);
        });

        AuthProvider().ValidateUserLogin();

        loadActiveIntegrations();

        if ((searchParams.get('state') == "Connect_1" || searchParams.get('state') == "Connect_3") && !hasInitConnection) {
            hasInitConnection = true;
            var activationCode = searchParams.get('code');
            var integrationType = searchParams.get('state') == "Connect_3" ? IntegrationType.Spiris : IntegrationType.Fortnox;
            IntegrationService.ConnectIntegration({
                accessCode: activationCode,
                integrationType: integrationType
            }).then(loadActiveIntegrations);
        }
    }, []);

    const loadActiveIntegrations = () => {
        IntegrationService.GetActiveIntegrations().then(result => {
            setActiveIntegrations(result);
            var fortNox = result.find(p => p.type == IntegrationType.Fortnox)
            var pingPayments = result.find(p => p.type == IntegrationType.PingPayments)
            var spirisVisma = result.find(p => p.type == IntegrationType.Spiris)

            fortNox ? setFortNoxIntegration(fortNox) : setFortNoxIntegration(null);
            pingPayments ? setPingPaymentsIntegration(pingPayments) : setPingPaymentsIntegration(null);
            spirisVisma ? setSpirisVismaIntegration(spirisVisma) : setSpirisVismaIntegration(null);
        });
    }

    const navigateToFortnox = async () => {
        var response = await IntegrationService.GetIntegration(IntegrationType.Fortnox);
        window.location.href = response.activationUri!;
    }

    const navigateToSpirisVisma = async () => {
        var response = await IntegrationService.GetIntegration(IntegrationType.Spiris);
        window.location.href = response.activationUri!;
    }

    const navigateToPingPaymentCreateMerchant = async () => {
        if (!company?.organisationNumber) {
            message.warning("Organisationsnummer behövs för att aktivera integrationen. Fyll i organisationsnummer under Konto och försök igen.")
            return;
        }

        navigation("/" + getCurrentLanguage() + "/pingpayments-integration");
    }

    const navigateToFortnoxMismatchReport = () => {
        navigation("/" + getCurrentLanguage() + "/integrations/mismatch-report?integration=fortnox");
    }

    const navigateToPingPaymentReport = () => {
        navigation("/" + getCurrentLanguage() + "/pingpayment-payment-report");
    }

    const navigateToSpirisMismatchReport = () => {
        navigation("/" + getCurrentLanguage() + "/integrations/mismatch-report?integration=spiris");
    }

    const openSyncConfig = async (integrationType: IntegrationType) => {
        try {
            const config = await IntegrationService.GetIntegrationSyncConfig(integrationType);
            syncConfigForm.setFieldsValue(config);
            setSyncConfigIntegrationType(integrationType);
            setShowSyncConfig(true);
        } catch {
            message.error(GetText("Integrations_SyncConfig_SaveError"));
        }
    };

    const saveSyncConfig = async () => {
        try {
            setIsSavingSyncConfig(true);
            const values = syncConfigForm.getFieldsValue();
            await IntegrationService.UpdateIntegrationSyncConfig({ ...values, integrationType: syncConfigIntegrationType });
            message.success(GetText("Integrations_SyncConfig_SaveSuccess"));
            setShowSyncConfig(false);
        } catch {
            message.error(GetText("Integrations_SyncConfig_SaveError"));
        } finally {
            setIsSavingSyncConfig(false);
        }
    };

    const syncIntegration = async (integrationType: IntegrationType) => {
        if (integrationType === IntegrationType.Fortnox) setIsLoadingFortnox(true);
        else setIsLoadingSpirisVisma(true);
        try {
            await IntegrationService.SyncFullIntegration(integrationType);
            message.success(GetText("Integrations_SyncMembersSuccess"));
            loadActiveIntegrations();
        } catch {
            message.error(GetText("Integrations_SyncMembersError"));
        } finally {
            if (integrationType === IntegrationType.Fortnox) setIsLoadingFortnox(false);
            else setIsLoadingSpirisVisma(false);
        }
    }

    const onDeleteClick = (memberId: number) => {
        setIntegrationToDelete(memberId);
    };

    const handleOk = async () => {
        await await IntegrationService.RemoveIntegration(integrationToDelete);
        loadActiveIntegrations();
        setIsLoadingFortnox(false);
        setIsLoadingPingPayments(false);
        setIsLoadingSpirisVisma(false);
    };
    return <LayoutLeftMenu title={GetText("Integrations_IntegrationTitle")} menu={<LeftMenuSettings selected={"integrations"} />}>
        <Space direction="vertical" size={0}>
            <Paragraph>{GetText("Integrations_Description")}</Paragraph>
            <Paragraph>
                <a target="_blank" rel="noreferrer" href={require('../../Pages/Contact/Documents/Guide_Integrationer.pdf')}>
                    <FilePdfOutlined style={{ color: "red" }} /> Guide Integrationer
                </a>
            </Paragraph>
        </Space>

        <div>
            <Row gutter={24}>
                <Col span={4}>

                    <Card
                        className='integration-card'
                        cover={
                            <img
                                alt="example"
                                src={require('../../Images/pingpayments.png')}
                            />
                        }>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <p style={{ height: "200px", flex: 1 }}>
                                Med ping payments kan du koppla ihop OneFront 360 och ta betalt av dina medlemmar/kunder och få automatisk avprickning vem som betalat. Klicka här för att koppla ihop OneFront 360 med Ping Payments.<br /><br />
                            </p>
                            <InfoCircleOutlined
                                style={{ fontSize: '20px', color: '#1890ff', cursor: 'pointer', marginLeft: '10px' }}
                                onClick={() => setShowPingPaymentsInfo(true)}
                                title="Visa priser och information"
                            />
                        </div>
                        <br />
                        {pingPaymentsIntegration ?
                            <>
                                {pingPaymentsIntegration.state == IntegrationState.Active ? <span><CheckCircleOutlined style={{ color: "green" }} /> Integrationen är aktiv.</span> : ""}

                                <Popconfirm
                                    title={GetText("Integrations_RemoveIntegrationConfirm")}
                                    key={pingPaymentsIntegration?.id!}
                                    open={pingPaymentsIntegration?.id! === integrationToDelete}
                                    placement="topRight"
                                    onConfirm={handleOk}
                                    onCancel={() => setIntegrationToDelete(0)}
                                >
                                </Popconfirm>
                                <br />
                                {pingPaymentsIntegration.state == IntegrationState.Error ? <><BookyButton fullWidth icon={<ApiOutlined />} loading={isLoadingPingPayments} style={{ marginTop: "10px" }} text={GetText("Integrations_Connect")} onClick={navigateToFortnox}></BookyButton><br /> </> : ""}
                                {pingPaymentsIntegration.state == IntegrationState.Active ? <BookyButton fullWidth icon={<FileTextOutlined />} style={{ marginTop: "10px" }} text="Utbetalningsrapport" onClick={navigateToPingPaymentReport}></BookyButton> : ""}
                                <BookyButton fullWidth icon={<DeleteOutlined />} style={{ marginTop: "10px" }} danger text={GetText("Integrations_RemoveIntegrationButton")} onClick={(e: any) => onDeleteClick(pingPaymentsIntegration?.id!)}></BookyButton>


                            </> : <BookyButton fullWidth loading={isLoadingPingPayments} disabled={pingPaymentsIntegration} style={{ marginTop: "10px" }} text={GetText("Integrations_Connect")} onClick={navigateToPingPaymentCreateMerchant}></BookyButton>
                        }

                    </Card>
                </Col>
                <Col span={4}>
                    <Card
                        className="integration-card"
                        cover={
                            <img
                                alt="example"
                                src={require('../../Images/fortnox.png')}
                            />
                        }>
                        {fortNoxIntegration ?
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <p style={{ height: "200px", flex: 1 }}>
                                        Med Fortnox kan du koppla ihop OneFront 360 och läsa in fakturor och betalningar för avprickning av medlemsavgift. Du kan även välja att synkronisera medlemsinformation per automatik.<br /><br />
                                    </p>
                                    <InfoCircleOutlined
                                        style={{ fontSize: '20px', color: '#1890ff', cursor: 'pointer', marginLeft: '10px' }}
                                        onClick={() => setShowFortnoxInfo(true)}
                                        title="Visa priser och information"
                                    />
                                </div>
                                {fortNoxIntegration.state == IntegrationState.Active ? <span><CheckCircleOutlined style={{ color: "green" }} /> Integrationen är aktiv.</span> : ""}

                                {fortNoxIntegration.state == IntegrationState.Error ? <span><ExclamationCircleOutlined style={{ color: "red" }} /> Fel inträffade vid senaste körningen. Tekniskt felmeddelande: <br /><i>{fortNoxIntegration.lastrunResponse}</i></span> : ""}


                                <br /><br />Senast synkroniserat: {formatDateString(fortNoxIntegration?.lastRun)}
                                <BookyButton fullWidth icon={<SyncOutlined />} loading={isLoadingFortnox} style={{ marginTop: "10px" }} text={GetText("Integrations_SyncButton")} onClick={() => syncIntegration(IntegrationType.Fortnox)}></BookyButton>
                                {fortNoxIntegration.state == IntegrationState.Active ? <BookyButton fullWidth icon={<SettingOutlined />} style={{ marginTop: "10px" }} text={GetText("Integrations_ConfigureSync")} onClick={() => openSyncConfig(IntegrationType.Fortnox)}></BookyButton> : ""}
                                {fortNoxIntegration.state == IntegrationState.Active ? <BookyButton fullWidth icon={<FileSearchOutlined />} style={{ marginTop: "10px" }} text={GetText("Integrations_OpenMismatchReport")} onClick={navigateToFortnoxMismatchReport}></BookyButton> : ""}

                                <Popconfirm
                                    title={GetText("Integrations_RemoveIntegrationConfirm")}
                                    key={fortNoxIntegration?.id!}
                                    open={fortNoxIntegration?.id! === integrationToDelete}
                                    placement="topRight"
                                    onConfirm={handleOk}
                                    onCancel={() => setIntegrationToDelete(0)}
                                >
                                </Popconfirm>
                                <br />
                                <BookyButton fullWidth icon={<DeleteOutlined />} style={{ marginTop: "10px" }} danger text={GetText("Integrations_RemoveIntegrationButton")} onClick={(e: any) => onDeleteClick(fortNoxIntegration?.id!)}></BookyButton>

                            </> : <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <p style={{ height: "200px", flex: 1 }}>
                                        Med Fortnox kan du koppla ihop OneFront 360 och läsa in fakturor och betalningar för avprickning av medlemsavgift. Du kan även välja att synkronisera medlemsinformation per automatik.<br /><br />
                                    </p>
                                    <InfoCircleOutlined
                                        style={{ fontSize: '20px', color: '#1890ff', cursor: 'pointer', marginLeft: '10px' }}
                                        onClick={() => setShowFortnoxInfo(true)}
                                        title="Visa priser och information"
                                    />
                                </div>
                                <BookyButton fullWidth loading={isLoadingFortnox} disabled={fortNoxIntegration} style={{ marginTop: "10px" }} text={GetText("Integrations_Connect")} onClick={navigateToFortnox}></BookyButton>
                            </>
                        }

                    </Card>
                </Col>
                <Col span={4}>
                    <Card
                        className="integration-card"
                        cover={
                            <img
                                alt="example"
                                src={require('../../Images/spiris_visma.png')}
                            />
                        }>
                        {spirisVismaIntegration ?
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <p style={{ height: "200px", flex: 1 }}>
                                        Med Spiris Visma kan du koppla ihop OneFront 360 och läsa in fakturor och betalningar för avprickning av medlemsavgift. Du kan även välja att synkronisera medlemsinformation per automatik.<br /><br />
                                    </p>
                                    <InfoCircleOutlined
                                        style={{ fontSize: '20px', color: '#1890ff', cursor: 'pointer', marginLeft: '10px' }}
                                        onClick={() => setShowSpirisInfo(true)}
                                        title="Visa priser och information"
                                    />
                                </div>
                                {spirisVismaIntegration.state == IntegrationState.Active ? <span><CheckCircleOutlined style={{ color: "green" }} /> Integrationen är aktiv.</span> : ""}

                                {spirisVismaIntegration.state == IntegrationState.Error ? <span><ExclamationCircleOutlined style={{ color: "red" }} /> Fel inträffade vid senaste körningen. Tekniskt felmeddelande: <br /><i>{spirisVismaIntegration.lastrunResponse}</i></span> : ""}


                                <br /><br />Senast synkroniserat: {formatDateString(spirisVismaIntegration?.lastRun)}
                                <BookyButton fullWidth icon={<SyncOutlined />} loading={isLoadingSpirisVisma} style={{ marginTop: "10px" }} text={GetText("Integrations_SyncButton")} onClick={() => syncIntegration(IntegrationType.Spiris)}></BookyButton>
                                {spirisVismaIntegration.state == IntegrationState.Active ? <BookyButton fullWidth icon={<SettingOutlined />} style={{ marginTop: "10px" }} text={GetText("Integrations_ConfigureSync")} onClick={() => openSyncConfig(IntegrationType.Spiris)}></BookyButton> : ""}
                                {spirisVismaIntegration.state == IntegrationState.Active ? <BookyButton fullWidth icon={<FileSearchOutlined />} style={{ marginTop: "10px" }} text={GetText("Integrations_OpenMismatchReport")} onClick={navigateToSpirisMismatchReport}></BookyButton> : ""}

                                <Popconfirm
                                    title={GetText("Integrations_RemoveIntegrationConfirm")}
                                    key={spirisVismaIntegration?.id!}
                                    open={spirisVismaIntegration?.id! === integrationToDelete}
                                    placement="topRight"
                                    onConfirm={handleOk}
                                    onCancel={() => setIntegrationToDelete(0)}
                                >
                                </Popconfirm>
                                <br />
                                {spirisVismaIntegration.state == IntegrationState.Error ? <><BookyButton fullWidth icon={<ApiOutlined />} loading={isLoadingSpirisVisma} style={{ marginTop: "10px" }} text={GetText("Integrations_Connect")} onClick={navigateToSpirisVisma}></BookyButton><br /> </> : ""}

                                <BookyButton fullWidth icon={<DeleteOutlined />} style={{ marginTop: "10px" }} danger text={GetText("Integrations_RemoveIntegrationButton")} onClick={(e: any) => onDeleteClick(spirisVismaIntegration?.id!)}></BookyButton>

                            </> : <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <p style={{ height: "200px", flex: 1 }}>
                                        Med Spiris Visma kan du koppla ihop OneFront 360 och läsa in fakturor och betalningar för avprickning av medlemsavgift. Du kan även välja att synkronisera medlemsinformation per automatik.<br /><br />
                                    </p>
                                    <InfoCircleOutlined
                                        style={{ fontSize: '20px', color: '#1890ff', cursor: 'pointer', marginLeft: '10px' }}
                                        onClick={() => setShowSpirisInfo(true)}
                                        title="Visa priser och information"
                                    />
                                </div>
                                <BookyButton fullWidth loading={isLoadingSpirisVisma} disabled={spirisVismaIntegration} style={{ marginTop: "10px" }} text={GetText("Integrations_Connect")} onClick={navigateToSpirisVisma}></BookyButton>
                            </>
                        }

                    </Card>
                </Col>
            </Row>
        </div>

        <Modal
            title={GetText("Integrations_SyncConfig_Title")}
            open={showSyncConfig}
            onCancel={() => setShowSyncConfig(false)}
            onOk={saveSyncConfig}
            confirmLoading={isSavingSyncConfig}
            okText="Spara"
            cancelText="Avbryt"
            width={560}
        >
            <Form form={syncConfigForm} layout="vertical">

                <Divider orientation="left">{GetText("Integrations_SyncConfig_Actions")}</Divider>

                <BookyCheckbox alignLabelRight noMarginBottom name="syncCreate" label={GetText("Integrations_SyncConfig_SyncCreate")} />
                <BookyCheckbox alignLabelRight noMarginBottom name="syncUpdateData" label={GetText("Integrations_SyncConfig_SyncUpdateData")} />
                <BookyCheckbox alignLabelRight noMarginBottom name="syncUpdateStatus" label={GetText("Integrations_SyncConfig_SyncUpdateStatus")} />

                <Divider orientation="left">{GetText("Integrations_SyncConfig_Fields")}</Divider>

                <BookyCheckbox alignLabelRight noMarginBottom name="syncName" label={GetText("Integrations_SyncConfig_SyncName")} />
                <BookyCheckbox alignLabelRight noMarginBottom name="syncEmail" label={GetText("Integrations_SyncConfig_SyncEmail")} />
                <BookyCheckbox alignLabelRight noMarginBottom name="syncEmailInvoice" label={GetText("Integrations_SyncConfig_SyncEmailInvoice")} />
                <BookyCheckbox alignLabelRight noMarginBottom name="syncPhone" label={GetText("Integrations_SyncConfig_SyncPhone")} />
                <BookyCheckbox alignLabelRight noMarginBottom name="syncAddress" label={GetText("Integrations_SyncConfig_SyncAddress")} />
                <BookyCheckbox alignLabelRight noMarginBottom name="syncZipCode" label={GetText("Integrations_SyncConfig_SyncZipCode")} />
                <BookyCheckbox alignLabelRight noMarginBottom name="syncCity" label={GetText("Integrations_SyncConfig_SyncCity")} />
                <BookyCheckbox alignLabelRight noMarginBottom name="syncPersonalNumber" label={GetText("Integrations_SyncConfig_SyncPersonalNumber")} />

                <Divider orientation="left">{GetText("Integrations_SyncConfig_Notes")}</Divider>

                <Form.Item name="syncExtraToNotes" label={GetText("Integrations_SyncConfig_SyncExtraToNotes")} style={{ marginBottom: 0 }}>
                    <Radio.Group>
                        <Radio value={null}>Ingen</Radio>
                        <Radio value={1}>{extra1Label}</Radio>
                        <Radio value={2}>{extra2Label}</Radio>
                        <Radio value={3}>{extra3Label}</Radio>
                    </Radio.Group>
                </Form.Item>

            </Form>
        </Modal>

        <Modal
            title="Fortnox - Priser och Information"
            open={showFortnoxInfo}
            onCancel={() => setShowFortnoxInfo(false)}
            footer={[
                <BookyButton key="close" onClick={() => setShowFortnoxInfo(false)} text="Stäng" />
            ]}
            width={700}
        >
            <div style={{ lineHeight: '1.8' }}>
                <h3>Priser per nivå</h3>
                <p>Samtliga priser är exklusive moms och debiteras årligen.</p>

                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Nivå</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Pris</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Bas 0-250</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>150 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Bas 250-500</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>300 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Bas 500-1000</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>500 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Premium</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>1 000 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Enterprise</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>2 500 kr</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Modal>

        <Modal
            title="Ping Payments - Priser och Information"
            open={showPingPaymentsInfo}
            onCancel={() => setShowPingPaymentsInfo(false)}
            footer={[
                <BookyButton key="close" onClick={() => setShowPingPaymentsInfo(false)} text="Stäng" />
            ]}
            width={700}
        >
            <div style={{ lineHeight: '1.8' }}>
                <h3>Automatiskt betalning</h3>
                <p>I denna integration kan ni automatisera medlemsinbetalningen. Ni behöver aldrig mer pricka av en faktura!</p>

                <h3>Automatisk avprickning</h3>
                <ul>
                    <li>Swish och kortbetalningar prickas av direkt.</li>
                    <li>BG-betalningar prickas av inom en bankdag.</li>
                </ul>

                <h3>Utbetalning</h3>
                <p>
                    Utbetalningar till föreningens konto sker varje fredag. En betalning
                    hålls kvar i cirka 2&ndash;3 veckor innan den betalas ut. Fördröjningen finns
                    så att föreningen enkelt kan göra återbetalningar genom systemet vid behov.
                </p>

                <h3>Priser</h3>
                <p>
                    Ni betalar en serviceavgift på 5-20 kr per betalning utifrån betalningens belopp.
                    Ett tips är att lägga på en avgift på 10-20 kr på era fakturor så blir tjänsten kostnadsfri för föreningen.
                </p>

                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Belopp</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Serviceavgift</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>1-200 kr</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>5 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>201-400 kr</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>8 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>401-700 kr</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>12 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>701-1500 kr</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>16 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>1501- kr</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>20 kr</td>
                        </tr>
                    </tbody>
                </table>

                <p style={{ marginTop: '15px' }}>
                    <strong>Observera:</strong> Om ni väljer att tillåta kort som betalsätt tillkommer en extra avgift på 0,6 - 2,5%
                    beroende på vilket betal- eller kreditkort som används.
                </p>
            </div>
        </Modal>

        <Modal
            title="Spiris Visma - Priser och Information"
            open={showSpirisInfo}
            onCancel={() => setShowSpirisInfo(false)}
            footer={[
                <BookyButton key="close" onClick={() => setShowSpirisInfo(false)} text="Stäng" />
            ]}
            width={700}
        >
            <div style={{ lineHeight: '1.8' }}>
                <h3>Priser per nivå</h3>
                <p>Samtliga priser är exklusive moms och debiteras årligen.</p>

                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Nivå</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Pris</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Bas 0-250</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>150 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Bas 250-500</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>300 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Bas 500-1000</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>500 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Premium</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>1 000 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Enterprise</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>2 500 kr</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Modal>
    </LayoutLeftMenu>
};

export default AdminIntegrations;